<template>
  <li class="flex mb-3">
    <font-awesome-icon
      :icon="['far', 'check-circle']"
      class="mr-1 mt-1"
      :class="isDefault ? 'text-white' : 'text-primary-color'"
    />
    <span>{{feature}}</span>
  </li>
</template>

<script>
export default {
  props: ["isDefault", "feature"],
};
</script>
